<template>
  <div>
    <el-card class="searchItemFlex">
          <el-badge is-dot class="item" :value="auditFailCount" :hidden="auditFailCount<=0">
            <el-radio-group v-model="query.state" @change="changeState">
              <el-radio-button v-for="item in productionWorkingLogStateOptions" :label="item.value" :key="item.value">{{ item.label }}</el-radio-button>
            </el-radio-group>
          </el-badge>
          
          <el-popover placement="top" width="900" trigger="hover">
            <div class="searchPopoverFlex">
              <space>
                <el-input class="searchPopoverItem" v-model="query.projectNum" placeholder="项目编号" clearable></el-input>

              <el-input class="searchPopoverItem" v-model="query.projectName" placeholder="项目名称" clearable></el-input>

              <el-input class="searchPopoverItem" v-model="query.processDetailName" placeholder="工序项名称" clearable></el-input>

              <el-input class="searchPopoverItem" v-model="query.creatorName" placeholder="录入人" clearable></el-input>

              <el-date-picker v-model="query.dateRange" type="daterange" value-format="yyyy-MM-dd" range-separator="至" 
              start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" format="yyyy-MM-dd"
              @change="getLogList"></el-date-picker>
              </space>
              
            </div>
            
            <el-button slot="reference">查询面板</el-button>
          </el-popover>
          <el-button type="primary" @click="search">查询</el-button>
          <el-button type="warning" @click="reset">重置</el-button>

      <div class="totalMoney right">
        总金额{{logTotalMoney}}元
      </div>
      <space>
        <el-link @click="handleExport"><i class="el-icon-download"></i>导出数据</el-link>
        <el-popover placement="top" width="600" trigger="click" title="请选择日期范围以导出报表数据包">
          <div>
            <space>
              <el-date-picker v-model="packageParam.dateRange" type="daterange" value-format="yyyy-MM-dd" range-separator="至" 
                start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" format="yyyy-MM-dd"></el-date-picker>
              <el-button type="primary" @click="handleExportPackage" :loading="exportLoading">确认导出</el-button>
            </space>
            
          </div>
          <el-link slot="reference"><i class="el-icon-download"></i> 导出报表数据包</el-link>
        </el-popover>
        
      </space>
      
    </el-card>
    <custom-table ref="AuditTable" id="logTable" :columns="columns" :data="logList" :pagination="query" storageKey="productionAudit"
      @pagination-change="({pageNum, pageSize}) => paginationChange(pageNum, pageSize, getLogList)" @sort-change="col => sortChange(col, getLogList)" @selection-change="handleSelectionChange">
      <div slot="toolbar">
        <el-button v-permission="['production_log_audit']" v-if="query.state === productionWorkingLogState.auditing || query.state === productionWorkingLogState.auditFail" type="success" icon="el-icon-arrow-left" @click="handleAudit(productionWorkingLogState.auditPass)">审核通过</el-button>
        <el-button v-permission="['production_log_audit']" v-if="query.state === productionWorkingLogState.auditing || query.state === productionWorkingLogState.auditPass" type="danger" @click="handleAudit(productionWorkingLogState.auditFail)">审核不通过<i class="el-icon-arrow-right el-icon--right"></i></el-button>
      </div>
      <el-table-column slot="selection" type="selection" width="35" fixed="left"></el-table-column>
      <el-table-column slot="detailPrice" label="工序价格" prop="detailPrice" width="90">
        <template v-slot="{ row }">
          {{ row.detailType === processDetailType.computeItem ? row.detailPrice : '-' }}
        </template>
      </el-table-column>
      <el-table-column slot="scrollCount" label="登记数量" prop="scrollCount" width="110" :sortable="'custom'">
        <template v-slot="{ row }">
          {{ row.detailType === processDetailType.computeItem ? row.scrollCount : '-' }}
        </template>
      </el-table-column>
      <el-table-column slot="totalMoney" label="总价/内容" width="165" show-overflow-tooltip>
        <template v-slot="{ row }">
          <el-tag v-if="row.detailType === processDetailType.computeItem">
            {{ getTotalMoney(row) }}
          </el-tag>
          <span v-else>
            {{ row.notes }}
          </span>
        </template>
      </el-table-column>
      <el-table-column slot="state" label="状态" prop="state" width="90">
        <template v-slot="{ row }">
          <el-tag :type="productionWorkingLogStateOptions.find(item => item.value === row.state).type">{{ productionWorkingLogStateOptions.find(item => item.value === row.state).label }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column slot="action" label="操作" min-width="140" fixed="right">
        <template v-slot="{ row }">
          <Space>
            <el-link v-if="row.userId.trim() === userId && [productionWorkingLogState.auditFail].includes(row.state)" @click="handleUpdate(row)">更新</el-link>
            <el-link type="danger" v-if="row.userId.trim() === userId && [productionWorkingLogState.auditFail].includes(row.state)" @click="handleDelete(row)">删除</el-link>
          </Space>
        </template>
      </el-table-column>
    </custom-table>
    <WorkingLogOperator ref="workingLogOperatorRef" @success="getLogList"></WorkingLogOperator>
  </div>
</template>

<script>
import WorkingLogOperator from '@/page/production/productionAudit/components/WorkingLogOperator.vue'
import { productionWorkingLogState, productionWorkingLogStateOptions } from '@/data/productionWorkingLogState';
import productionWorkingLogApi from '@/api/productionWorkingLogApi';
import { processDetailType } from '@/data/processDetailType';
import { paginationFuncMixin } from '@/mixins/paginationFunc'
import { defaultPaginationSetting } from '@/data/paginationSetting'
import Decimal from 'decimal.js'
import XLSX from "xlsx"
import dayjs from 'dayjs'
import FileSaver from 'file-saver'
import productionProjectApi from '@/api/productionProjectApi';
export default {
  name: 'ProductionAudit',
  mixins: [paginationFuncMixin],
  components: {
    WorkingLogOperator
  },
  data() {
    return {
      visible: false,
      loading: false,
      productionWorkingLogStateOptions,
      productionWorkingLogState,
      processDetailType,
      query: {
        projectNum: '',
        projectName: '',
        processDetailName: '',
        creatorName: '',
        dateRange: [],
        state: productionWorkingLogState.auditing,
        orderColumn: 'createTime',
        isAsc: false,
        ...defaultPaginationSetting,
        pageSizes: [20, 100, 200, 500, 1000 ],
      },
      logList: [],
      logTotalMoney: 0,
      selectedLogList: [],
      userId: JSON.parse(sessionStorage.getItem('userInfo')).userId,
      auditFailCount: 0,
      columns: [
        { label: '多选', prop: 'selection', type: 'selection', width: 55, stable: true },
        { label: '生产日期', prop: 'createTime', width: 145, sortable: 'custom', defaultRender: true},
        { label: '项目编号', prop: 'projectNum', width: 160 , defaultRender: true},
        { label: '项目名称', prop: 'projectName', width: 180 , defaultRender: true},
        { label: '录入人', prop: 'createUserName', width: 120, sortable: 'custom', defaultRender: true },
        { label: '工序名称', prop: 'detailName', width: 200 , defaultRender: true},
        { label: '工序价格', prop: 'detailPrice', width: 90 },
        { label: '登记数量', prop: 'scrollCount', width: 110, sortable: 'custom' },
        { label: '总价/内容', prop:'totalMoney', width: 165, },
        { label: '备注', prop: 'description',  width: 140, defaultRender: true },
        { label: '状态', prop: 'state', width: 90 },
        { label: '审核人', prop: 'auditorName', width: 120, defaultRender: true },
        { label: '审核时间', prop: 'auditTime', width: 145, sortable: 'custom', defaultRender: true },
        { label: '操作', prop:'action', stable: true }
      ],
      pickerOptions: {
          shortcuts: [{
            text: '上个月',
            onClick(picker) {
              const date = new Date()
              let year = date.getFullYear()
              let month = date.getMonth()
              month === 0 ? month = 12 : month++
              year = month === 12 ? year - 1 : year
              const firstDay = `${year}-${month}-01`
              const lastDay = `${year}-${month}-${new Date(year, month, 0).getDate()}`
              const start = new Date(firstDay)
              const end = new Date(lastDay)
              console.log(start, end)
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '本月',
            onClick(picker) {
              const date = new Date()
              const year = date.getFullYear()
              const month = date.getMonth() + 1
              const firstDay = `${year}-${month}-01`
              const lastDay = `${year}-${month}-${new Date(year, month, 0).getDate()}`
              const start = new Date(firstDay)
              const end = new Date(lastDay)
              picker.$emit('pick', [start, end]);
            }
          }, 
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
      },
      packageParam: {
        dateRange: []
      },
      exportLoading: false,
    }
  },
  mounted() {
    this.getLogList()
  },
  methods: {
    async getLogList() {
      this.loading = true
      const {data: res} = await productionWorkingLogApi.logAuditPage(this.query).catch(err => err)
      if (res) {
        this.logList = res.records
        this.query.total = res.total
        this.logTotalMoney = res.totalMoney || 0
        this.getAuditFailCount()
      }
      this.loading = false
    },
    search() {
      this.getLogList()
    },
    reset() {
      this.query = {
        projectNum: '',
        projectName: '',
        processDetailName: '',
        creatorName: '',
        dateRange: [],
        state: productionWorkingLogState.auditing,
        orderColumn: 'createTime',
        isAsc: false,

        ...defaultPaginationSetting
      }
      this.getLogList()
    },
    handleUpdate(row){
      this.$refs.workingLogOperatorRef.onOpen(row)
    },
    handleSelectionChange(val) {
      this.selectedLogList = val
    },
    getTotalMoney(row) {
      return Decimal(row.detailPrice || 0).times(Decimal(row.scrollCount || 0)).toFixed(2)
    },
    async handleAudit(auditState){
      if(this.selectedLogList.length <= 0) {
        return this.$message.warning('请选择要审核的记录')
      }
      const text = auditState === productionWorkingLogState.auditPass ? '通过' : '拒绝'
      const conf = await this.$confirm(`是否${text}选中的${this.selectedLogList.length}条记录？`, '提示', { type: 'warning' }).catch(err => err)
      if(conf !== 'confirm') return this.$message.info('操作已取消')
      this.loading = true
      const selectedLogIdList = this.selectedLogList.map(item => item.id)
      const { data: res } = await productionWorkingLogApi.logAudit(selectedLogIdList, auditState).catch(err => err)
      if(res) {
        this.$message.success('操作成功')
        this.getLogList()
        this.selectedLogList = []
        this.$store.dispatch('message/setMessageCount')
      }
      this.loading = false
    },
    async getAuditFailCount() {
      const { data: res } = await productionWorkingLogApi.auditFailCount().catch(err => err)
      if(res || res === 0) {
        this.auditFailCount = res
      }
    },
    async handleDelete(row){
      const conf = await this.$confirm('是否删除选中的记录？', '提示', { type: 'warning' }).catch(err => err)
      if(conf !== 'confirm') return this.$message.info('操作已取消')
      this.loading = true
      const { data: res } = await productionWorkingLogApi.delLog(row.id).catch(err => err)
      if(res) {
        this.$message.success('操作成功')
        this.getLogList()
      }
      this.loading = false
    },
    changeState() {
      if(this.query.state === productionWorkingLogState.auditPass){
        // 将dateRange改为本月第一天到今天
        const date = new Date()
        const year = date.getFullYear()
        const month = date.getMonth() + 1
        const firstDay = `${year}-${month}-01`
        const today = `${year}-${month}-${date.getDate() === 1 ? 2 : date.getDate()}`
        this.query.dateRange = [firstDay, today]
      }else{
        // 清空dateRange
        this.query.dateRange = []
      }
      this.getLogList()
    },
    async handleExport() {
      this.loading = true
      // 改为从后端查询数据
      this.$message.warning("正在导出产量记录数据...")
      const noStateQuery = {...this.query}
      delete noStateQuery.state
      const {data: res} = await productionWorkingLogApi.logAuditPage(noStateQuery).catch(err => err)
      if(!res) {
        this.loading = false
        return this.$message.warning('数据为空，导出失败，请稍后重试')
      }
      const allLogList = res.records
      if(!allLogList || allLogList.length <= 0) {
        this.loading = false
        return this.$message.warning('数据为空，导出失败，请稍后重试')
      }
      
      // 基于数据源构建导出数据，避免重复
      const exportData = allLogList.map(row => {
        // 获取状态标签
        const stateLabel = this.productionWorkingLogStateOptions.find(item => item.value === row.state)?.label || ''
        
        return {
          '生产日期': row.createTime,
          '项目编号': row.projectNum,
          '项目名称': row.projectName,
          '录入人': row.createUserName,
          '工序名称': row.detailName,
          '工序价格': row.detailType === this.processDetailType.computeItem ? row.detailPrice : '-',
          '登记数量': row.detailType === this.processDetailType.computeItem ? row.scrollCount : '-',
          '总价/内容': row.detailType === this.processDetailType.computeItem ? this.getTotalMoney(row) : row.notes,
          '备注': row.description,
          '状态': stateLabel,
          '审核人': row.auditorName,
          '审核时间': row.auditTime
        }
      })
      
      // 创建工作簿和工作表
      var wb = XLSX.utils.book_new()
      var ws = XLSX.utils.json_to_sheet(exportData)
      
      // 将工作表添加到工作簿
      XLSX.utils.book_append_sheet(wb, ws, "产量记录")
      
      // 生成Excel文件
      var wbout = XLSX.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "array",
      })
      
      try {
        FileSaver.saveAs(
          new Blob([wbout], {
            type: "application/octet-stream;charset=utf-8",
          }),
          `产量记录导出_${dayjs().format('YYYYMMDD') }.xlsx`
        )
        this.loading = false
        //导出完成
        this.$message.success("导出成功！")
        return wbout
      } catch (e) {
        this.loading = false
        if (typeof console !== "undefined") console.log(e, wbout)
        this.$message.error("导出失败，请重试")
      }
    },
    async handleExportPackage() {
      if(!this.packageParam.dateRange || this.packageParam.dateRange.length <= 0) {
        return this.$message.warning('请选择日期范围')
      }
      const conf = await this.$confirm('是否确定导出报表数据包？', '提示', { type: 'warning' }).catch(err => err)
      if (conf !== 'confirm') {
        return this.$message.info('已取消操作')
      }
      this.exportLoading = true
      const {data: res} = await productionProjectApi.exportPackage(this.packageParam).catch(err => err)      
      if (!res) {
				this.$message.error("下载失败")
        this.exportLoading = false
				return
			} else {
        console.log(res)
        const now = dayjs().format('YYYYMMDD_HHmmss')
				let filename = `批量导出数据包_${now}.xlsx`
				//构造a标签 通过a标签来下载
				let url = window.URL.createObjectURL(new Blob([res]))
				let a = document.createElement("a")
				a.style.display = "none"
				a.href = url
				//此处的download是a标签的内容，固定写法，不是后台api接口
				a.setAttribute("download", filename)
				document.body.appendChild(a)
				//点击下载
				a.click()
				// 下载完成移除元素
				document.body.removeChild(a)
				// 释放掉blob对象
				window.URL.revokeObjectURL(url)
				this.$message.success("导出完成~")
			}
      this.exportLoading = false
    }
  }
}
</script>

<style lang="less" scoped>
.totalMoney{
  font-size: 14px;
  font-weight: normal;
  color: #909399;
}
.searchPopoverFlex{
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  justify-content: flex-start;
  .searchPopoverItem{
    width: 120px;
  }
}
</style>
